<h6>Vendor Gallery ({{ vendorImages.length }})</h6>
<div class="d-flex flex-wrap gap-3">
  <ng-container *ngFor="let attachment of vendorImages">
    <!-- preview image -->
    <div *ngIf="attachment.isImage" style="width: 200px" class="position-relative">
      <a href="javascript:void(0)" (click)="onDownloadFile(attachment)">
        <img
          [src]="(attachment.url | secureImage | async).image"
          alt=""
          class="w-100 rounded border"
          style="height: 200px; object-fit: cover"
        />
      </a>
    </div>
  </ng-container>
</div>
